import { put } from 'redux-saga/effects';
import { select as typedSelect } from 'typed-redux-saga';

import { configSlice } from '..';
import { RootState } from '../../../../../init-store';

/**
 *
 */
function* setDesktopAppPromoClosed() {
    const { user } = yield* typedSelect((state: RootState) => state);

    if (user) {
        document.cookie = 'desktopAppPromoClosed=true; path=/; max-age=315360000';
    }
    yield put(configSlice.actions.setDesktopAppPromoClosed());
}

export default setDesktopAppPromoClosed;
